// @ts-ignore
export const isFirefox = typeof InstallTrigger !== 'undefined';
